import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpJwtInterceptor } from './http-jwt.interceptor';
import { HttpXsrfInterceptor } from './http-xcrsf.interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpJwtInterceptor, multi: true },
  //{ provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true }
];
